import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            dark: {
                primary: "#3f51b5",
                secondary: "#424242",
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#52c41a",
                warning: "#faad14",
            },
            light: {
                primary: "#20a8d8",
                secondary: "#424242",
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#52c41a",
                warning: "#faad14",
            },
        },
    },
    icons: {
        iconfont: "mdi", // default - only for display purposes
    },
});